import {
  JobsConfigurationCommand,
  JobsConfigurationJob
} from "modules/system/sections/plt/field-management/rings/rollout-package/configure/jobs/dtos";
import { useJobsFormOperations } from "modules/system/sections/plt/field-management/rings/rollout-package/configure/jobs/jobs.hooks";
import { useState } from "react";

import { IconButton } from "@bps/fluent-ui";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";
import { Permissions } from "@libs/permissions/permissions.enum";

import { CommandEditHost } from "./edit";

interface CommandEditButtonProps {
  job: JobsConfigurationJob;
  command: JobsConfigurationCommand;
}

export const CommandEditButton: React.FC<CommandEditButtonProps> = ({
  job,
  command
}) => {
  const { data: hasWritePermission } = usePermissionsCheckQuery(
    Permissions.PltFieldManagementWrite
  );

  const { updateCommand } = useJobsFormOperations();

  const [showEdit, setShowEdit] = useState(false);
  return (
    <>
      <IconButton
        onClick={() => setShowEdit(true)}
        styles={{
          root: {
            background: "transparent"
          }
        }}
        iconProps={{ iconName: "Edit" }}
        title={!hasWritePermission ? NO_ACTION_PERMISSION : undefined}
      />

      <CommandEditHost
        modeLabel="Edit"
        job={job}
        command={command}
        hidden={!showEdit}
        onDismiss={() => setShowEdit(false)}
        onUpdate={updateCommand}
      />
    </>
  );
};
